var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 20.878,
    cy: 21,
    rx: 20.286,
    ry: 21,
    fill: "#353535"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9485_27862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.644 16.933v-4.69a.55.55 0 00-.252-.443.611.611 0 00-.478-.078l-9.992 4.117h-4.933a2.558 2.558 0 00-2.215 1.407l-.453.182c-1.147.412-1.915 1.531-1.913 2.788-.007 1.252.765 2.367 1.913 2.762l.302.13a2.653 2.653 0 001.258 1.433l1.334 5.002c.358 1.361 1.714 2.164 3.028 1.793.53-.15.997-.477 1.327-.933a2.76 2.76 0 00.402-2.266l-.906-3.44h.856l9.992 4.195.176.052a.59.59 0 00.302-.078.497.497 0 00.252-.417V23.5c1.751 0 3.17-1.47 3.17-3.283s-1.419-3.283-3.17-3.283zm-18.122 5.002c-.672-.278-1.098-.97-1.057-1.72-.04-.748.385-1.44 1.057-1.719v3.44zm6.242 7.817c-.277.386-.718.61-1.183.6a1.521 1.521 0 01-1.41-1.147l-1.182-4.508h3.045l.957 3.7c.13.464.047.964-.227 1.355zm.806-6.097h-4.581c-.763.043-1.416-.562-1.458-1.352a1.458 1.458 0 01-.002-.107v-3.7c-.028-.863.625-1.586 1.458-1.615h4.582v6.774zm10.067 4.012l-9.06-3.751v-7.14l9.06-3.751v14.643zm1.007-5.21v-4.482c1.195 0 2.164 1.003 2.164 2.241 0 1.237-.969 2.24-2.164 2.24z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9485_27862"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.408 9.45)",
    d: "M0 0h23.407v24.231H0z"
  })))));
}
SvgAnnouncement.displayName = 'Announcement';
export default SvgAnnouncement;